import { mockFormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsPersonFieldset } from '../../models/appliance-details-stepped/cms-person-fieldset.interface';

export const mockCmsPersonFieldset: CmsPersonFieldset = {
  ...mockFormFieldset,
  addressFieldset: mockFormOverrideAddressFieldset,
  firstNameField: mockFormField,
  lastNameField: mockFormField,
  titleIdField: mockFormField,
};
